var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"list-none my-1 mx-0 border-b dark:border-gray-700",attrs:{"tabindex":null,"aria-disabled":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }